import { MultiContainer, Typography } from '@shared/ui'
import { useTranslation } from 'react-i18next'
import styles from './ErrorPage.module.scss'
import oops from '@shared/assets/images/oops.svg'

export const ErrorPage = () => {
  const { t } = useTranslation()
  return (
    <MultiContainer>
      <div className={styles.wrapper}>
        <div className={styles.image}>
          <img src={oops} alt='something went wrong' />
        </div>
        <div className={styles.content}>
          <Typography variant='h1' color='black'>
            {t('error.title')}
          </Typography>
          <Typography variant='h4regular' color='black'>
            {t('error.desc')}
          </Typography>
        </div>
      </div>
    </MultiContainer>
  )
}
